import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { ElementCategory, StandardType } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  StandardImageElement,
} from "@easy-email-pro-core/typings";
import React from "react";
import { Image } from "@easy-email-pro-core/components/Elements";

import { Image as SourceElement } from "../../basic/Image";

const defaultData: ElementDefinition<StandardImageElement>["defaultData"] =
  mergeBlock(SourceElement.defaultData, {
    attributes: {},
    data: {},
  });

export const StandardImage = createBlock<StandardImageElement>({
  get name() {
    return t("Image");
  },
  void: true,
  defaultData,
  type: StandardType.STANDARD_IMAGE,
  create: (payload) => {
    const defaultData: StandardImageElement = {
      type: StandardType.STANDARD_IMAGE,
      data: {},
      attributes: {},
      children: [],
    };

    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.IMAGE,
  render(params) {
    const { node } = params;
    const {
      "border-enabled": borderEnabled,
      "border-width": borderWidth,
      "border-style": borderStyle,
      "border-color": borderColor,
      ...attributes
    } = node.attributes;

    const border = borderEnabled
      ? `${borderWidth} ${borderStyle} ${borderColor}`
      : "";

    return (
      <Image
        idx={params.idx}
        {...attributes}
        data={node.data}
        border={border}
        children={params.children || node.children}
      />
    );
  },
});
